import React from 'react'
import ListComponentProto from './list-proto'


export default function renderListInList(id:string, props:any) {
    return (
        <ListComponentProto
            renderMode="list"
            id={id}
            {...props}
        />
    )
}
